import React from 'react';
import { Stack, Text } from '../ui';
import { useNomineeEstates } from '../hooks/useNomineeEstates';

/**
 * Estate context line for nominee estate detail pages (owner name, not Cognito sub).
 */
export default function NomineeEstateHeading({ ownerSub, title }) {
  const { labelForOwnerSub } = useNomineeEstates();
  const label = labelForOwnerSub(ownerSub);

  return (
    <Stack gap={6}>
      <Text as="div" size="sm" muted>Estate</Text>
      <Text as="div" weight={700} style={{ margin: 0 }}>{label}</Text>
      <Text as="h1" size="xl" weight={800} style={{ margin: 0 }}>{title}</Text>
    </Stack>
  );
}
